import { TooltipSizes } from './Tooltip';
import TooltipWrapper from './TooltipWrapper';
import useTooltip from './useTooltip';

const Tooltip = TooltipWrapper;

export { TooltipSizes, useTooltip };

export default Tooltip;
